// This file can be replaced during build by using the `fileReplacements` array.

// `ng build` replaces `environment.ts` with `environment.prod.ts`.

// The list of file replacements can be found in `angular.json`.

export const environment = {
  // * config
  production: false,
  local: false,
  favicon: 'assets/images/logo-dev.ico',
  api: 'services/api',
  file: 'https://dev-storage.darwintech.it/public/dev-sviluppo-personale/',
};
